//
// Autogenerated by Thrift Compiler (0.7.0-en-11139b3b5cb61e817408c6e84b0e1c258bf6c6ae)
//
// DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
//


  // Define types and services

  var Thrift = require('evernote-thrift').Thrift;
  var Types = require('./Types');
  var Errors = require('./Errors');
  var AuthenticationTypes = require('./AuthenticationTypes');


  module.exports.LoginStatus = {
    'UNKNOWN' : 0,
    'INVALID_FORMAT' : 1,
    'NOT_FOUND' : 2,
    'INVITE_PENDING' : 3,
    'PASSWORD_RESET' : 4,
    'PASSWORD' : 5,
    'SSO' : 6
  };

  module.exports.BusinessUserType = {
    'UNKNOWN' : 0,
    'PERSONAL_ONLY' : 1,
    'LEGACY' : 2,
    'BUSINESS_ONLY' : 3
  };

  module.exports.EDAM_VERSION_MAJOR = 1;

  module.exports.EDAM_VERSION_MINOR = 28;

  module.exports.PublicUserInfo = Thrift.Struct.define('PublicUserInfo',  {
    1: { alias: 'userId', type: Thrift.Type.I32 },
    2: { alias: 'shardId', type: Thrift.Type.STRING },
    3: { alias: 'privilege', type: Thrift.Type.I32 },
    7: { alias: 'serviceLevel', type: Thrift.Type.I32 },
    4: { alias: 'username', type: Thrift.Type.STRING },
    5: { alias: 'noteStoreUrl', type: Thrift.Type.STRING },
    6: { alias: 'webApiUrlPrefix', type: Thrift.Type.STRING }
  });

  module.exports.UserUrls = Thrift.Struct.define('UserUrls',  {
    1: { alias: 'noteStoreUrl', type: Thrift.Type.STRING },
    2: { alias: 'webApiUrlPrefix', type: Thrift.Type.STRING },
    3: { alias: 'userStoreUrl', type: Thrift.Type.STRING },
    4: { alias: 'utilityUrl', type: Thrift.Type.STRING },
    5: { alias: 'messageStoreUrl', type: Thrift.Type.STRING },
    6: { alias: 'userWebSocketUrl', type: Thrift.Type.STRING },
    7: { alias: 'communicationEngineUrl', type: Thrift.Type.STRING },
    8: { alias: 'workspaceDashboardUrl', type: Thrift.Type.STRING },
    9: { alias: 'workspaceDirectoryUrl', type: Thrift.Type.STRING }
  });

  module.exports.AuthenticationResult = Thrift.Struct.define('AuthenticationResult',  {
    1: { alias: 'currentTime', type: Thrift.Type.I64 },
    2: { alias: 'authenticationToken', type: Thrift.Type.STRING },
    3: { alias: 'expiration', type: Thrift.Type.I64 },
    4: { alias: 'user', type: Thrift.Type.STRUCT, def: Types.User },
    5: { alias: 'publicUserInfo', type: Thrift.Type.STRUCT, def: module.exports.PublicUserInfo },
    6: { alias: 'noteStoreUrl', type: Thrift.Type.STRING },
    7: { alias: 'webApiUrlPrefix', type: Thrift.Type.STRING },
    8: { alias: 'secondFactorRequired', type: Thrift.Type.BOOL },
    9: { alias: 'secondFactorDeliveryHint', type: Thrift.Type.STRING },
    10: { alias: 'urls', type: Thrift.Type.STRUCT, def: module.exports.UserUrls }
  });

  module.exports.LocalizedString = Thrift.Struct.define('LocalizedString',  {
    1: { alias: 'zh', type: Thrift.Type.STRING },
    2: { alias: 'en', type: Thrift.Type.STRING }
  });

  module.exports.BootstrapSettings = Thrift.Struct.define('BootstrapSettings',  {
    1: { alias: 'serviceHost', type: Thrift.Type.STRING },
    2: { alias: 'marketingUrl', type: Thrift.Type.STRING },
    3: { alias: 'supportUrl', type: Thrift.Type.STRING },
    4: { alias: 'accountEmailDomain', type: Thrift.Type.STRING },
    14: { alias: 'cardscanUrl', type: Thrift.Type.STRING },
    15: { alias: 'announcementsUrl', type: Thrift.Type.STRING },
    5: { alias: 'enableFacebookSharing', type: Thrift.Type.BOOL },
    6: { alias: 'enableGiftSubscriptions', type: Thrift.Type.BOOL },
    7: { alias: 'enableSupportTickets', type: Thrift.Type.BOOL },
    8: { alias: 'enableSharedNotebooks', type: Thrift.Type.BOOL },
    9: { alias: 'enableSingleNoteSharing', type: Thrift.Type.BOOL },
    10: { alias: 'enableSponsoredAccounts', type: Thrift.Type.BOOL },
    11: { alias: 'enableTwitterSharing', type: Thrift.Type.BOOL },
    12: { alias: 'enableLinkedInSharing', type: Thrift.Type.BOOL },
    13: { alias: 'enablePublicNotebooks', type: Thrift.Type.BOOL },
    16: { alias: 'enableGoogle', type: Thrift.Type.BOOL },
    17: { alias: 'isShowYXRegister', type: Thrift.Type.BOOL },
    18: { alias: 'isShowYXLogin', type: Thrift.Type.BOOL },
    19: { alias: 'isShowENRegister', type: Thrift.Type.BOOL },
    20: { alias: 'YXRegisterViewMsg', type: Thrift.Type.STRUCT, def: module.exports.LocalizedString },
    21: { alias: 'YXLoginViewMsg', type: Thrift.Type.STRUCT, def: module.exports.LocalizedString },
    22: { alias: 'isShowENLogin', type: Thrift.Type.BOOL },
    23: { alias: 'ENLoginViewMsg', type: Thrift.Type.STRUCT, def: module.exports.LocalizedString },
    24: { alias: 'YXLoginENEntranceMsg', type: Thrift.Type.STRUCT, def: module.exports.LocalizedString }
  });

  module.exports.BootstrapProfile = Thrift.Struct.define('BootstrapProfile',  {
    1: { alias: 'name', type: Thrift.Type.STRING },
    2: { alias: 'settings', type: Thrift.Type.STRUCT, def: module.exports.BootstrapSettings }
  });

  module.exports.BootstrapInfo = Thrift.Struct.define('BootstrapInfo',  {
    1: { alias: 'profiles', type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRUCT, module.exports.BootstrapProfile)  }
  });

  module.exports.PushNotificationCredentials = Thrift.Struct.define('PushNotificationCredentials',  {
    1: { alias: 'iosDeviceToken', type: Thrift.Type.BINARY },
    2: { alias: 'gcmRegistrationId', type: Thrift.Type.STRING }
  });

  module.exports.RegisterForSyncPushNotificationsResult = Thrift.Struct.define('RegisterForSyncPushNotificationsResult',  {
    1: { alias: 'sharedSecret', type: Thrift.Type.BINARY }
  });

  module.exports.MultiRegisterForSyncPushNotificationsResult = Thrift.Struct.define('MultiRegisterForSyncPushNotificationsResult',  {
    1: { alias: 'userId', type: Thrift.Type.STRING },
    2: { alias: 'sharedSecret', type: Thrift.Type.BINARY }
  });

  module.exports.AuthenticationParameters = Thrift.Struct.define('AuthenticationParameters',  {
    1: { alias: 'usernameOrEmail', type: Thrift.Type.STRING },
    2: { alias: 'password', type: Thrift.Type.STRING },
    3: { alias: 'ssoLoginToken', type: Thrift.Type.STRING },
    4: { alias: 'consumerKey', type: Thrift.Type.STRING },
    5: { alias: 'consumerSecret', type: Thrift.Type.STRING },
    6: { alias: 'deviceIdentifier', type: Thrift.Type.STRING },
    7: { alias: 'deviceDescription', type: Thrift.Type.STRING },
    8: { alias: 'supportsTwoFactor', type: Thrift.Type.BOOL },
    9: { alias: 'supportsBusinessOnlyAccounts', type: Thrift.Type.BOOL },
    10: { alias: 'openIdCredential', type: Thrift.Type.STRUCT, def: AuthenticationTypes.OpenIdCredential }
  });

  module.exports.BusinessInviteInfo = Thrift.Struct.define('BusinessInviteInfo',  {
    1: { alias: 'businessId', type: Thrift.Type.I32 }
  });

  module.exports.GetLoginInfoRequest = Thrift.Struct.define('GetLoginInfoRequest',  {
    1: { alias: 'usernameOrEmail', type: Thrift.Type.STRING },
    2: { alias: 'openIdCredential', type: Thrift.Type.STRUCT, def: AuthenticationTypes.OpenIdCredential }
  });

  module.exports.LoginInfo = Thrift.Struct.define('LoginInfo',  {
    1: { alias: 'loginStatus', type: Thrift.Type.I32 },
    2: { alias: 'pendingInvites', type: Thrift.Type.SET, def: Thrift.Set.define(Thrift.Type.STRUCT, module.exports.BusinessInviteInfo) },
    3: { alias: 'businessUserType', type: Thrift.Type.I32 }
  });

  var UserStore = module.exports.UserStore = {};

  UserStore.checkVersion = Thrift.Method.define({
    alias: 'checkVersion',
    args: Thrift.Struct.define('checkVersionArgs', {
      1: { alias: 'clientName', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'edamVersionMajor', type: Thrift.Type.I16, index: 1 },
      3: { alias: 'edamVersionMinor', type: Thrift.Type.I16, index: 2 }
    }),
    result: Thrift.Struct.define('checkVersionResult', {
      0: { alias: 'returnValue',type: Thrift.Type.BOOL }
    })
  });

  UserStore.getBootstrapInfo = Thrift.Method.define({
    alias: 'getBootstrapInfo',
    args: Thrift.Struct.define('getBootstrapInfoArgs', {
      1: { alias: 'locale', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('getBootstrapInfoResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.BootstrapInfo }
    })
  });

  UserStore.getYXBootstrapInfo = Thrift.Method.define({
    alias: 'getYXBootstrapInfo',
    args: Thrift.Struct.define('getYXBootstrapInfoArgs', {
      1: { alias: 'locale', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('getYXBootstrapInfoResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.BootstrapInfo }
    })
  });

  UserStore.authenticate = Thrift.Method.define({
    alias: 'authenticate',
    args: Thrift.Struct.define('authenticateArgs', {
      1: { alias: 'username', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'password', type: Thrift.Type.STRING, index: 1 },
      3: { alias: 'consumerKey', type: Thrift.Type.STRING, index: 2 },
      4: { alias: 'consumerSecret', type: Thrift.Type.STRING, index: 3 },
      5: { alias: 'supportsTwoFactor', type: Thrift.Type.BOOL, index: 4 }
    }),
    result: Thrift.Struct.define('authenticateResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.AuthenticationResult },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.authenticateOpenID = Thrift.Method.define({
    alias: 'authenticateOpenID',
    args: Thrift.Struct.define('authenticateOpenIDArgs', {
      1: { alias: 'credential', type: Thrift.Type.STRUCT, def: AuthenticationTypes.OpenIdCredential, index: 0 },
      2: { alias: 'consumerKey', type: Thrift.Type.STRING, index: 1 },
      3: { alias: 'consumerSecret', type: Thrift.Type.STRING, index: 2 },
      4: { alias: 'deviceIdentifier', type: Thrift.Type.STRING, index: 3 },
      5: { alias: 'deviceDescription', type: Thrift.Type.STRING, index: 4 },
      6: { alias: 'authLongSession', type: Thrift.Type.BOOL, index: 5 },
      7: { alias: 'supportsTwoFactor', type: Thrift.Type.BOOL, index: 6 }
    }),
    result: Thrift.Struct.define('authenticateOpenIDResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.AuthenticationResult },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.authenticateLongSession = Thrift.Method.define({
    alias: 'authenticateLongSession',
    args: Thrift.Struct.define('authenticateLongSessionArgs', {
      1: { alias: 'username', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'password', type: Thrift.Type.STRING, index: 1 },
      3: { alias: 'consumerKey', type: Thrift.Type.STRING, index: 2 },
      4: { alias: 'consumerSecret', type: Thrift.Type.STRING, index: 3 },
      5: { alias: 'deviceIdentifier', type: Thrift.Type.STRING, index: 4 },
      6: { alias: 'deviceDescription', type: Thrift.Type.STRING, index: 5 },
      7: { alias: 'supportsTwoFactor', type: Thrift.Type.BOOL, index: 6 }
    }),
    result: Thrift.Struct.define('authenticateLongSessionResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.AuthenticationResult },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.authenticateLongSessionV2 = Thrift.Method.define({
    alias: 'authenticateLongSessionV2',
    args: Thrift.Struct.define('authenticateLongSessionV2Args', {
      1: { alias: 'authParams', type: Thrift.Type.STRUCT, def: module.exports.AuthenticationParameters, index: 0 }
    }),
    result: Thrift.Struct.define('authenticateLongSessionV2Result', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.AuthenticationResult },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.completeTwoFactorAuthentication = Thrift.Method.define({
    alias: 'completeTwoFactorAuthentication',
    args: Thrift.Struct.define('completeTwoFactorAuthenticationArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'oneTimeCode', type: Thrift.Type.STRING, index: 1 },
      3: { alias: 'deviceIdentifier', type: Thrift.Type.STRING, index: 2 },
      4: { alias: 'deviceDescription', type: Thrift.Type.STRING, index: 3 }
    }),
    result: Thrift.Struct.define('completeTwoFactorAuthenticationResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.AuthenticationResult },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.revokeLongSession = Thrift.Method.define({
    alias: 'revokeLongSession',
    args: Thrift.Struct.define('revokeLongSessionArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('revokeLongSessionResult', {
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.authenticateToBusiness = Thrift.Method.define({
    alias: 'authenticateToBusiness',
    args: Thrift.Struct.define('authenticateToBusinessArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('authenticateToBusinessResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.AuthenticationResult },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.refreshAuthentication = Thrift.Method.define({
    alias: 'refreshAuthentication',
    args: Thrift.Struct.define('refreshAuthenticationArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('refreshAuthenticationResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.AuthenticationResult },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.getUser = Thrift.Method.define({
    alias: 'getUser',
    args: Thrift.Struct.define('getUserArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('getUserResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: Types.User },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.getPublicUserInfo = Thrift.Method.define({
    alias: 'getPublicUserInfo',
    args: Thrift.Struct.define('getPublicUserInfoArgs', {
      1: { alias: 'username', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('getPublicUserInfoResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.PublicUserInfo },
      1: { alias: 'notFoundException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMNotFoundException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException },
      3: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException }
    })
  });

  UserStore.getPremiumInfo = Thrift.Method.define({
    alias: 'getPremiumInfo',
    args: Thrift.Struct.define('getPremiumInfoArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('getPremiumInfoResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: Types.PremiumInfo },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.getSubscriptionInfo = Thrift.Method.define({
    alias: 'getSubscriptionInfo',
    args: Thrift.Struct.define('getSubscriptionInfoArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('getSubscriptionInfoResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: Types.SubscriptionInfo },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.getNoteStoreUrl = Thrift.Method.define({
    alias: 'getNoteStoreUrl',
    args: Thrift.Struct.define('getNoteStoreUrlArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('getNoteStoreUrlResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRING },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.getUserUrls = Thrift.Method.define({
    alias: 'getUserUrls',
    args: Thrift.Struct.define('getUserUrlsArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('getUserUrlsResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.UserUrls },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.inviteToBusiness = Thrift.Method.define({
    alias: 'inviteToBusiness',
    args: Thrift.Struct.define('inviteToBusinessArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'emailAddress', type: Thrift.Type.STRING, index: 1 }
    }),
    result: Thrift.Struct.define('inviteToBusinessResult', {
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.removeFromBusiness = Thrift.Method.define({
    alias: 'removeFromBusiness',
    args: Thrift.Struct.define('removeFromBusinessArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'emailAddress', type: Thrift.Type.STRING, index: 1 }
    }),
    result: Thrift.Struct.define('removeFromBusinessResult', {
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException },
      3: { alias: 'notFoundException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMNotFoundException }
    })
  });

  UserStore.updateBusinessUserIdentifier = Thrift.Method.define({
    alias: 'updateBusinessUserIdentifier',
    args: Thrift.Struct.define('updateBusinessUserIdentifierArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'oldEmailAddress', type: Thrift.Type.STRING, index: 1 },
      3: { alias: 'newEmailAddress', type: Thrift.Type.STRING, index: 2 }
    }),
    result: Thrift.Struct.define('updateBusinessUserIdentifierResult', {
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException },
      3: { alias: 'notFoundException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMNotFoundException }
    })
  });

  UserStore.listBusinessUsers = Thrift.Method.define({
    alias: 'listBusinessUsers',
    args: Thrift.Struct.define('listBusinessUsersArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'businessUserFilter', type: Thrift.Type.STRUCT, def: Types.BusinessUserFilter, index: 1 }
    }),
    result: Thrift.Struct.define('listBusinessUsersResult', {
      0: { alias: 'returnValue',type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRUCT, Types.UserProfile)  },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.listBusinessUsersProfileInfo = Thrift.Method.define({
    alias: 'listBusinessUsersProfileInfo',
    args: Thrift.Struct.define('listBusinessUsersProfileInfoArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'businessUserFilter', type: Thrift.Type.STRUCT, def: Types.BusinessUserFilter, index: 1 },
      3: { alias: 'userProfileInfoRequest', type: Thrift.Type.STRUCT, def: Types.UserProfileInfoRequest, index: 2 }
    }),
    result: Thrift.Struct.define('listBusinessUsersProfileInfoResult', {
      0: { alias: 'returnValue',type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRUCT, Types.UserProfile)  },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.listBusinessInvitations = Thrift.Method.define({
    alias: 'listBusinessInvitations',
    args: Thrift.Struct.define('listBusinessInvitationsArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'includeRequestedInvitations', type: Thrift.Type.BOOL, index: 1 }
    }),
    result: Thrift.Struct.define('listBusinessInvitationsResult', {
      0: { alias: 'returnValue',type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRUCT, Types.BusinessInvitation)  },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.registerForSyncPushNotifications = Thrift.Method.define({
    alias: 'registerForSyncPushNotifications',
    args: Thrift.Struct.define('registerForSyncPushNotificationsArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'credentials', type: Thrift.Type.STRUCT, def: module.exports.PushNotificationCredentials, index: 1 }
    }),
    result: Thrift.Struct.define('registerForSyncPushNotificationsResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.RegisterForSyncPushNotificationsResult },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException },
      3: { alias: 'notFoundException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMNotFoundException }
    })
  });

  UserStore.multiRegisterForSyncPushNotifications = Thrift.Method.define({
    alias: 'multiRegisterForSyncPushNotifications',
    args: Thrift.Struct.define('multiRegisterForSyncPushNotificationsArgs', {
      1: { alias: 'authenticationTokens', type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRING) , index: 0 },
      2: { alias: 'credentials', type: Thrift.Type.STRUCT, def: module.exports.PushNotificationCredentials, index: 1 }
    }),
    result: Thrift.Struct.define('multiRegisterForSyncPushNotificationsResult', {
      0: { alias: 'returnValue',type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.STRUCT, module.exports.MultiRegisterForSyncPushNotificationsResult)  },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException },
      3: { alias: 'notFoundException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMNotFoundException }
    })
  });

  UserStore.unregisterForSyncPushNotifications = Thrift.Method.define({
    alias: 'unregisterForSyncPushNotifications',
    args: Thrift.Struct.define('unregisterForSyncPushNotificationsArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('unregisterForSyncPushNotificationsResult', {
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException },
      3: { alias: 'notFoundException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMNotFoundException }
    })
  });

  UserStore.createSessionAuthenticationToken = Thrift.Method.define({
    alias: 'createSessionAuthenticationToken',
    args: Thrift.Struct.define('createSessionAuthenticationTokenArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 }
    }),
    result: Thrift.Struct.define('createSessionAuthenticationTokenResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRING },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException },
      3: { alias: 'notFoundException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMNotFoundException }
    })
  });

  UserStore.getAccountLimits = Thrift.Method.define({
    alias: 'getAccountLimits',
    args: Thrift.Struct.define('getAccountLimitsArgs', {
      1: { alias: 'serviceLevel', type: Thrift.Type.I32, index: 0 }
    }),
    result: Thrift.Struct.define('getAccountLimitsResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: Types.AccountLimits },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException }
    })
  });

  UserStore.getConnectedIdentities = Thrift.Method.define({
    alias: 'getConnectedIdentities',
    args: Thrift.Struct.define('getConnectedIdentitiesArgs', {
      1: { alias: 'authenticationToken', type: Thrift.Type.STRING, index: 0 },
      2: { alias: 'identityIds', type: Thrift.Type.LIST, def: Thrift.List.define(Thrift.Type.I64) , index: 1 }
    }),
    result: Thrift.Struct.define('getConnectedIdentitiesResult', {
      0: { alias: 'returnValue',type: Thrift.Type.MAP, def: Thrift.Map.define(Thrift.Type.I64, Thrift.Type.STRUCT, Types.Identity)  },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  UserStore.getLoginInfo = Thrift.Method.define({
    alias: 'getLoginInfo',
    args: Thrift.Struct.define('getLoginInfoArgs', {
      1: { alias: 'getLoginInfoRequest', type: Thrift.Type.STRUCT, def: module.exports.GetLoginInfoRequest, index: 0 }
    }),
    result: Thrift.Struct.define('getLoginInfoResult', {
      0: { alias: 'returnValue',type: Thrift.Type.STRUCT, def: module.exports.LoginInfo },
      1: { alias: 'userException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMUserException },
      2: { alias: 'systemException', type: Thrift.Type.EXCEPTION, def: Errors.EDAMSystemException }
    })
  });

  // Define UserStore Client

  function UserStoreClient(output) {
    this.output = output;
    this.seqid = 0;
  }

  UserStoreClient.prototype.checkVersion = function(clientName, edamVersionMajor, edamVersionMinor, callback) {
    var mdef = UserStore.checkVersion;
    var args = new mdef.args();
    args.clientName = clientName;
    args.edamVersionMajor = edamVersionMajor;
    args.edamVersionMinor = edamVersionMinor;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getBootstrapInfo = function(locale, callback) {
    var mdef = UserStore.getBootstrapInfo;
    var args = new mdef.args();
    args.locale = locale;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getYXBootstrapInfo = function(locale, callback) {
    var mdef = UserStore.getYXBootstrapInfo;
    var args = new mdef.args();
    args.locale = locale;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.authenticate = function(username, password, consumerKey, consumerSecret, supportsTwoFactor, callback) {
    var mdef = UserStore.authenticate;
    var args = new mdef.args();
    args.username = username;
    args.password = password;
    args.consumerKey = consumerKey;
    args.consumerSecret = consumerSecret;
    args.supportsTwoFactor = supportsTwoFactor;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.authenticateOpenID = function(credential, consumerKey, consumerSecret, deviceIdentifier, deviceDescription, authLongSession, supportsTwoFactor, callback) {
    var mdef = UserStore.authenticateOpenID;
    var args = new mdef.args();
    args.credential = credential;
    args.consumerKey = consumerKey;
    args.consumerSecret = consumerSecret;
    args.deviceIdentifier = deviceIdentifier;
    args.deviceDescription = deviceDescription;
    args.authLongSession = authLongSession;
    args.supportsTwoFactor = supportsTwoFactor;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.authenticateLongSession = function(username, password, consumerKey, consumerSecret, deviceIdentifier, deviceDescription, supportsTwoFactor, callback) {
    var mdef = UserStore.authenticateLongSession;
    var args = new mdef.args();
    args.username = username;
    args.password = password;
    args.consumerKey = consumerKey;
    args.consumerSecret = consumerSecret;
    args.deviceIdentifier = deviceIdentifier;
    args.deviceDescription = deviceDescription;
    args.supportsTwoFactor = supportsTwoFactor;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.authenticateLongSessionV2 = function(authParams, callback) {
    var mdef = UserStore.authenticateLongSessionV2;
    var args = new mdef.args();
    args.authParams = authParams;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.completeTwoFactorAuthentication = function(authenticationToken, oneTimeCode, deviceIdentifier, deviceDescription, callback) {
    var mdef = UserStore.completeTwoFactorAuthentication;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    args.oneTimeCode = oneTimeCode;
    args.deviceIdentifier = deviceIdentifier;
    args.deviceDescription = deviceDescription;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.revokeLongSession = function(authenticationToken, callback) {
    var mdef = UserStore.revokeLongSession;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.authenticateToBusiness = function(authenticationToken, callback) {
    var mdef = UserStore.authenticateToBusiness;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.refreshAuthentication = function(authenticationToken, callback) {
    var mdef = UserStore.refreshAuthentication;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getUser = function(authenticationToken, callback) {
    var mdef = UserStore.getUser;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getPublicUserInfo = function(username, callback) {
    var mdef = UserStore.getPublicUserInfo;
    var args = new mdef.args();
    args.username = username;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getPremiumInfo = function(authenticationToken, callback) {
    var mdef = UserStore.getPremiumInfo;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getSubscriptionInfo = function(authenticationToken, callback) {
    var mdef = UserStore.getSubscriptionInfo;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getNoteStoreUrl = function(authenticationToken, callback) {
    var mdef = UserStore.getNoteStoreUrl;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getUserUrls = function(authenticationToken, callback) {
    var mdef = UserStore.getUserUrls;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.inviteToBusiness = function(authenticationToken, emailAddress, callback) {
    var mdef = UserStore.inviteToBusiness;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    args.emailAddress = emailAddress;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.removeFromBusiness = function(authenticationToken, emailAddress, callback) {
    var mdef = UserStore.removeFromBusiness;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    args.emailAddress = emailAddress;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.updateBusinessUserIdentifier = function(authenticationToken, oldEmailAddress, newEmailAddress, callback) {
    var mdef = UserStore.updateBusinessUserIdentifier;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    args.oldEmailAddress = oldEmailAddress;
    args.newEmailAddress = newEmailAddress;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.listBusinessUsers = function(authenticationToken, businessUserFilter, callback) {
    var mdef = UserStore.listBusinessUsers;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    args.businessUserFilter = businessUserFilter;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.listBusinessUsersProfileInfo = function(authenticationToken, businessUserFilter, userProfileInfoRequest, callback) {
    var mdef = UserStore.listBusinessUsersProfileInfo;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    args.businessUserFilter = businessUserFilter;
    args.userProfileInfoRequest = userProfileInfoRequest;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.listBusinessInvitations = function(authenticationToken, includeRequestedInvitations, callback) {
    var mdef = UserStore.listBusinessInvitations;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    args.includeRequestedInvitations = includeRequestedInvitations;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.registerForSyncPushNotifications = function(authenticationToken, credentials, callback) {
    var mdef = UserStore.registerForSyncPushNotifications;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    args.credentials = credentials;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.multiRegisterForSyncPushNotifications = function(authenticationTokens, credentials, callback) {
    var mdef = UserStore.multiRegisterForSyncPushNotifications;
    var args = new mdef.args();
    args.authenticationTokens = authenticationTokens;
    args.credentials = credentials;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.unregisterForSyncPushNotifications = function(authenticationToken, callback) {
    var mdef = UserStore.unregisterForSyncPushNotifications;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.createSessionAuthenticationToken = function(authenticationToken, callback) {
    var mdef = UserStore.createSessionAuthenticationToken;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getAccountLimits = function(serviceLevel, callback) {
    var mdef = UserStore.getAccountLimits;
    var args = new mdef.args();
    args.serviceLevel = serviceLevel;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getConnectedIdentities = function(authenticationToken, identityIds, callback) {
    var mdef = UserStore.getConnectedIdentities;
    var args = new mdef.args();
    args.authenticationToken = authenticationToken;
    args.identityIds = identityIds;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  UserStoreClient.prototype.getLoginInfo = function(getLoginInfoRequest, callback) {
    var mdef = UserStore.getLoginInfo;
    var args = new mdef.args();
    args.getLoginInfoRequest = getLoginInfoRequest;
    mdef.sendRequest(this.output, this.seqid++, args, callback);
  };

  module.exports.UserStore.Client = UserStoreClient;

  // Define UserStore Server

  function UserStoreServer(service, stransport, Protocol) {
    var methodName;
      this.service = service;
      this.stransport = stransport;
      this.processor = new Thrift.Processor();
      for (methodName in UserStore) {
        if (service[methodName]) {
          this.processor.addMethod(UserStore[methodName], service[methodName].bind(service));
        }
      }
      this.stransport.process = function (input, output, noop) {
      var inprot = new Protocol(input);
      var outprot = new Protocol(output);
      this.processor.process(inprot, outprot, noop);
    }.bind(this);
  }

  UserStoreServer.prototype.start = function () {
    this.stransport.listen();
  };
  UserStoreServer.prototype.stop = function () {
    this.stransport.close();
  };

  module.exports.UserStore.Server = UserStoreServer;

